import { render, staticRenderFns } from "./ClienteCreate.vue?vue&type=template&id=204e5810&scoped=true&"
import script from "./ClienteCreate.vue?vue&type=script&lang=js&"
export * from "./ClienteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e5810",
  null
  
)

export default component.exports